import axios from "axios";
import env from '../../../../env/env';

/**
 * This function is intended to be used as a React effect to fetch all the data for Conductors
 * in order to display them in the querybuilder.
 */
export default function fetchConductors(setConfig) {
    let conductors;
    let listValues = [];
    axios.post(env.ELASTIC_API_URL + '/orchard_index/_search/', {
        "size": 0,
        "aggs": {
            "conductors": {
                "terms": {
                    "field": "conductor_exact",
                    "size": 100,
                }
            }
        }})
        .then((res) => {

            conductors = res.data.aggregations.conductors.buckets;

            // sort alphabetically
            conductors.sort((a, b) => a.key.localeCompare(b.key));

            for (let conductor of conductors) {
                listValues.push({value: conductor.key, title: conductor.key, path: []});
            }

            setConfig(prevConfig => {
                return {
                    ...prevConfig,
                    fields: {
                        ...prevConfig.fields,
                            conductor_exact: {
                                ...prevConfig.fields.conductor_exact,
                                fieldSettings: {
                                    ...prevConfig.fields.conductor_exact.fieldSettings,
                                    listValues
                                }
                            }
                    }
                }
            })
        })
        .catch((err) => console.log(err));
}